import { Injectable } from '@angular/core';
import { Note } from "../shared/note.model";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { NoteAcknowledgementResponse } from "./note-acknowledgement.model";

@Injectable({
    providedIn: 'root'
})
export class NoteAcknowledgementsService {

    constructor(
        private http: HttpClient
    ) { }

    acknowledgeNote(note: Pick<Note, '_links'>): Observable<NoteAcknowledgementResponse> {
        return this.http.post<NoteAcknowledgementResponse>('/api/noteAcknowledgements', { note: note._links.self.href })
    }

}
